import { Component } from '@angular/core';
import { NavController, ModalController, AlertController } from 'ionic-angular';
import { IonicPage, NavParams } from 'ionic-angular';
import { VariablesProvider } from '../../providers/variables/variables';
import { PicajesPage } from '../../pages/picajes/picajes';
import { ViewController } from 'ionic-angular';
import { CalendarioPage } from '../../pages/calendario/calendario';
import { LoginPage } from '../../pages/login/login';
import { FormBuilder, FormGroup, Validators} from '@angular/forms';
//import { FuncionesProvider } from '../../providers/funciones/funciones';

@Component({
	selector: 'page-objetoslin',
  templateUrl: 'objetoslin.html'
})
export class ObjetoslinPage {
  diasdefiesta;
  myForm: FormGroup;
  myForm1: FormGroup;
  myForm2: FormGroup;
  misapp: Array<{title: string, descripcion: string, imagen: string , component: any}>;
  formulario = {codigo1: "",nombre1: "",empresa1: "",obra1: "",turno1: "",horas1: "",activo1: ""}
  resultado;
  date: string;
  type: 'string'; // 'string' | 'js-date' | 'moment' | 'time' | 'object'
  minuto = []; //= {valor: "1",color: "1"}
  color = []; //= {valor: "1",color: "1"}
  cabecera = []; //= {valor: "1",color: "1"}
  trabajadores;
  empresas;
  obras;
  puestos;
  turnos;
  valo="654321123456" ;
  formulario2 = {valor: ""}
  trabajadoresKeys;
  values:Array<string> = [];
  rs_xls;
  muestragif;
  form_padre;
  
  posicion: number = 0;
  pos: number = 0 ;
  itemData: any = [];
  items = [];
  grupoid;
  caption: string;
  lbl1: string;
  rsx;
  
  constructor(
    public fb: FormBuilder,
    private alertCtrl: AlertController,
    public modalCtrl: ModalController,
    public variables:VariablesProvider,    
    public params: NavParams,
    public viewCtrl: ViewController
    //public funciones:FuncionesProvider
  ) {
    
    this.myForm = this.fb.group({id: [''], nombre: ['' ], activo: ['' ] });
 
    this.caption = params.get('caption');
    this.grupoid = params.get('idgrupo');
    this.form_padre =  params.get('form_padre');

    this.rsx = [];
    this.rsx = params.get('rsx');
    //this.trabajadores = params.get('rstrabajadores');
    this.empresas= [];
    this.empresas= params.get('rsempresas');
    this.obras= [];
    this.obras= params.get('rsobras');
    this.puestos=  [];
    this.puestos= params.get('rspuestos');
    this.turnos=  [];
    this.turnos= params.get('rsturnos');

    if(this.grupoid==""){


    }

   //console.clear();
    //console.log("Objetos" + this.empresas);
    //console.log("Empresa:" + this.empresas[0].NOMBRE);


  this.myForm = this.fb.group({

      codigo: [''],
      nombre: ['' ],
      empresa: ['' ],
      obra: ['' ],
      turno: ['' ],
      horas: ['' ],
      activo: ['']
    
     });

 
  this.ponencampo("","");

//    this.obtenertrabajadores(this.valo);
  }

seleccionar(codigo,nombre){


  //console.log("Form_padre:" + this.form_padre);
 
  if (this.form_padre=='grupos'){

  this.resultado=[];

   this.variables.grabargruposlin(this.grupoid,codigo).then(
     data => {
          this.resultado = data;

          this.variables.seltrabajador(this.formulario.empresa1,this.formulario.obra1,this.formulario.turno1,this.grupoid).then(
            data => {
            this.trabajadores = data;
          }
          )
          .catch(
            error => {
              console.log(error);
          }
        )

     })

  }else{

    //console.log("Se va ya ..." + codigo + " " + nombre);
    this.viewCtrl.dismiss(
      {
        'codigo': codigo,
        'nombre': nombre
      }
    );
    } 

  }

  dismiss() {
    //console.log("Se va...");
    this.viewCtrl.dismiss(
      {
        'trabajadores': "this.puestos",
        'turnos': "this.turnos"
      }
    ); 
  }

  ponencampo(campo:string, value:string):void{

     this.trabajadores = [];
      this.muestragif = "si"

      switch (campo) {
         case "EMPRESA":
            this.formulario.empresa1 = value;
           break;
         case "OBRA":
           this.formulario.obra1 = value;
           break;
         case "TURNO":
           this.formulario.turno1 = value;
           break;
         case "ACTIVO":
           this.formulario.activo1 = value;
           break;
         
         default:
           // code...
           break;
      }
      
      if (this.formulario.empresa1==''){
        this.formulario.empresa1='654321123456';
      }
      if (this.formulario.obra1==''){
        this.formulario.obra1='654321123456';
      }
      if (this.formulario.turno1==''){
        this.formulario.turno1='654321123456';
      }


      this.variables.seltrabajador(this.formulario.empresa1,this.formulario.obra1,this.formulario.turno1,this.grupoid).then(
          data => {
          this.trabajadores = data;
        }
      )
        .catch(
          error => {
            console.log(error);
        }
      )
      this.muestragif = "no"
    }
}


// WEBPACK FOOTER //
// ./src/pages/objetoslin/objetoslin.ts